var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
var isRefreshing = false;
var failedQueue = [];
var processQueue = function (error, response) {
    while (failedQueue.length > 0) {
        var _a = failedQueue.shift(), resolve = _a.resolve, reject = _a.reject;
        if (error)
            reject(error);
        else
            resolve(response);
    }
};
var attachAuthInterceptor = function (instance) {
    instance.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(void 0, void 0, void 0, function () {
        var originalRequest, refreshResponse, refreshError_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    originalRequest = error.config;
                    if (!(((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401 &&
                        !originalRequest._retry &&
                        !((_b = originalRequest.url) === null || _b === void 0 ? void 0 : _b.includes("token/refresh")))) return [3 /*break*/, 5];
                    originalRequest._retry = true;
                    if (isRefreshing) {
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                failedQueue.push({ resolve: resolve, reject: reject });
                            }).then(function () { return instance(originalRequest); })];
                    }
                    isRefreshing = true;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, axios.post("/dj-rest-auth/token/refresh/", null, { withCredentials: true })];
                case 2:
                    refreshResponse = _c.sent();
                    processQueue(null, refreshResponse);
                    return [2 /*return*/, instance(originalRequest)];
                case 3:
                    refreshError_1 = _c.sent();
                    processQueue(refreshError_1);
                    return [2 /*return*/, Promise.reject(refreshError_1)];
                case 4:
                    isRefreshing = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/, Promise.reject(error)];
            }
        });
    }); });
};
// Normal API instance
var api = axios.create({
    baseURL: "/api/v1",
    withCredentials: true,
});
attachAuthInterceptor(api);
var djRestAuth = axios.create({
    baseURL: "/dj-rest-auth",
    withCredentials: true,
});
attachAuthInterceptor(djRestAuth);
export { api, djRestAuth };
